import { camelCase, startCase } from 'lodash-es'
export const pascalCase = (str: string) => startCase(camelCase(str)).replace(/ /g, '')
